import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPointDefaultPath = _resolveComponent("IconPointDefaultPath")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createBlock(_component_IconBase, {
    width: _ctx.iconSize,
    height: _ctx.iconSize,
    "icon-color": "transparent",
    "view-box": "0 0 24 24"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_IconPointDefaultPath, {
        "bg-color": _ctx.bgColor,
        "icon-color": _ctx.iconColor,
        "border-color": _ctx.borderColor
      }, null, 8, ["bg-color", "icon-color", "border-color"])
    ]),
    _: 1
  }, 8, ["width", "height"]))
}